<template>
  <div class="flex-col add-Info">
    <div class="flex-col content-info">
      <form action="">
        <div class="flex-col">
          <!-- 公司 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('CompanyName') }}</label><span class="must-input">* </span>
            </div>
            <div class="flex-col red-bg"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="company"
                :readonly="companyDisable"
                v-model="company.name"
                autocomplete="off"
                @blur="onBlur('company')"
                @keyup="getMyDeBounce($event,'company')"
                @change="selectChange($event,'company')"
                :placeholder="$t('CompanyNameTips')">
              <select-panel v-show="company.show"
                :component-name="company.componentName"
                :loading="company.loading"
                :data-list="company.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>

          <!-- @click="getFilterList($event,'company')" -->
          <!-- 用户 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('CompanyContactName') }}</label><span class="must-input">* </span>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="user"
                :readonly="userDisable"
                v-model="user.name"
                autocomplete="off"
                :placeholder="$t('CompanyContactNameTips')"
                @click="getFilterList($event,'user')"
                @blur="onBlur('user')"
                @keyup="getMyDeBounce($event,'user')"
                @change="selectChange($event,'user')">
              <select-panel v-show="user.show"
                :component-name="user.componentName"
                :loading="user.loading"
                :data-list="user.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>

          <!-- 关系深度 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('RelationDeepth') }}</label><span class="must-input">* </span>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                ref="relationDeepth"
                type="text"
                readonly
                v-model="relationDeepth.name"
                autocomplete="off"
                @click="getFilterList($event,'relationDeepth')"
                @blur="onBlur('relationDeepth')"
                @keyup="getFilterList($event,'relationDeepth')"
                @change="selectChange($event,'relationDeepth')"
                :placeholder="$t('RelationDeepthTips')">

              <select-panel v-show="relationDeepth.show"
                :component-name="relationDeepth.componentName"
                :loading="relationDeepth.loading"
                :data-list="relationDeepth.showList"
                @itemClick="selectItem"></select-panel>

            </div>
          </div>

          <!--  职务 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('CompanyContactPosition') }}</label> <span class="must-input">* </span>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="position"
                :readonly="positionDisable"
                v-model="user.position"
                autocomplete="off"
                :placeholder="$t('CompanyContactPositionTips')">
            </div>
          </div>

          <!--  备注 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label>{{ $t('remark') }}</label>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="remark"
                :disabled="remarkDisable"
                v-model="remark"
                autocomplete="off"
                :placeholder="$t('remarkTips')">
            </div>
          </div>

        </div>
      </form>
      <div class="submit-button">
        <van-button round
          block
          type="info"
          native-type="submit"
          @click="onSubmit">
          {{ $t('common.commitTip') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from "lodash";
import commonjs from "@/common/common";
import userInfo from "@/common/loginInfo";
import { Toast } from "vant";
import SelectPanel from "@/components/common/SelectPanel"

var companyDe, userDe;
export default {
  name: "companyRelationship",
  components: {
    Toast,
    SelectPanel
  },
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      isEdit: false,
      isShowBack: false,
      id: null,
      categoryList: [],
      responsibilityList: [],
      deepList: [],
      userList: [],
      oldPosition: null,
      companyDisable: false,
      userDisable: false,
      responsibilityDisable: false,
      remarkDisable: false,
      positionDisable: false,
      company: {
        name: "",
        showList: [],
        item: {},
        show: false,
        componentName: "company",
        loading: false,
      },
      user: {
        name: "",
        showList: [],
        item: {},
        show: false,
        position: "",
        componentName: "user",
        loading: false,
      },
      responsibility: {
        name: "",
        showList: [],
        item: {},
        show: false,
      },
      relationDeepth: {
        name: "",
        showList: [],
        item: {},
        show: false,
        componentName: "relationDeepth",
        loading: false,
      },
      remark: "",
      oldPeorganizationId: '',
    };
  },

  watch: {
    "user.name": {
      handler: function () {
        if (this.isEdit) return;
        //新增时特殊处理，人工添加新联系人
        console.log("user.name", this.user);
        var newName = _.trim(this.user.name);
        if (this.user.item == null || this.user.item.name != newName) {
          var find = _.find(this.user.showList, ["name", newName]);
          if (find) {
            this.user.item = find;
            this.user.position = find.position;
            if (commonjs.isEmpty(find.position)) {
              this.positionDisable = false;
            } else {
              this.positionDisable = true;
            }
          } else {
            this.user.item = null;
            this.user.position = "";
            this.positionDisable = false;
          }
        }
      },
    },
  },
  created () {
    this.onInitData();
    companyDe = _.debounce(this.getMycompanyList, 100);
    userDe = _.debounce(this.getUserList, 100);
    var memberid = this.$route.query.id;
    var companyData = this.$route.query.companyData;
    //从机构公司页面过来
    if (companyData) {
      console.log(companyData);
      this.isShowBack = true;
      this.company.name = companyData.name;
      this.company.item = companyData;
      this.company.nameEn = "";
    }
    if (memberid) {
      this.isShowBack = true;
      this.isEdit = true;
      webService
        .getInvestedCompanyContactDetails(memberid)
        .then((res) => {
          this.company.name = res.data.companyName;
          this.company.item.name = res.data.companyName;
          this.company.item.id = res.data.companyGuid;
          this.company.item.apiID = res.data.companyId;
          this.oldPeorganizationId = res.data.companyGuid;

          this.user.name = res.data.name;
          this.user.item.name = res.data.name;
          this.user.item.id = res.data.id;
          this.user.position = res.data.position;
          this.oldPosition = res.data.position;
          this.relationDeepth.name = res.data.relationDeepthName;
          this.relationDeepth.item.id = res.data.relationDeepthId;
          //只能编辑关系深度
          //   this.companyDisable = true;
          this.userDisable = true;
          //   this.responsibilityDisable = true;
          this.remarkDisable = false;
          this.id = res.data.investedCompanyRelationshipId;
        });
    }

    var relationshipId = this.$route.query.relationshipId;
    if (relationshipId) {
      this.isEdit = true;
      this.isShowBack = true;
      webService
        .getInvestedCompanyContactDetails(relationshipId)
        .then((res) => {
          this.company.name = res.data.companyName;
          this.company.item.name = res.data.companyName;
          this.company.item.id = res.data.companyGuid;
          this.company.item.apiID = res.data.companyId;
          this.user.name = res.data.name;
          this.user.item.name = res.data.name;
          this.user.item.id = res.data.id;
          this.user.position = res.data.position;
          this.oldPosition = res.data.position;
          this.relationDeepth.name = res.data.relationDeepthName;
          this.relationDeepth.item.id = res.data.relationDeepthId;
          this.remark = res.data.relationRemark;
          //只能编辑关系深度
          //   this.companyDisable = true;
          this.userDisable = true;
          this.responsibilityDisable = false;
          this.remarkDisable = false;
          this.id = res.data.investedCompanyRelationshipId;
        });
    }
  },
  methods: {
    onInitData: function () {
      this.getCommonInfo();
    },
    getCommonInfo () {
      var param = [
        commonjs.commonInfoEnmus.Responsibility,
        commonjs.commonInfoEnmus.Title,
        commonjs.commonInfoEnmus.RelationDeepth,
      ];
      webService.getCommonInfo(param).then((res) => {
        this.categoryList = res.data;
        this.responsibilityList = _.filter(
          this.categoryList,
          function (m) {
            return (
              m.category ==
              commonjs.commonInfoEnmus.Responsibility
            );
          }
        );
        this.deepList = _.filter(this.categoryList, function (m) {
          return (
            m.category == commonjs.commonInfoEnmus.RelationDeepth
          );
        });
      });
    },
    onSubmit: function () {
      if (this.valudateBeforeSubmit()) {
        if (this.company.item) {
          if (
            (this.company.item.name &&
              this.company.item.name !== this.company.name) ||
            !this.company.item.name
          ) {
            //Toast.fail('请选择系统中存在的机构');
            this.company.item = null;
            this.company.show = false;
          }
        }

        var addInfo = {
          InvestedCompanyName: this.company.name,
          InvestedCompanyId:
            this.company.item != null && this.company.item.id
              ? this.company.item.id
              : null,
          OldPeorganizationId: this.oldPeorganizationId,
          CompanyMemberName: this.user.name,
          CompanyMemberId:
            this.user.item != null && this.user.item.id
              ? this.user.item.id
              : null,
          Position: this.user.position,
          ResponsibilityName: this.responsibility.name,
          ResponsibilityId:
            this.responsibility.item != null &&
              this.responsibility.item.id
              ? this.responsibility.item.id
              : null,
          RelationDeepthId:
            this.relationDeepth.item != null &&
              this.relationDeepth.item.id
              ? this.relationDeepth.item.id
              : null,
          UserId: userInfo.userToken.userId,
          UserProfileName: userInfo.userToken.userName,
          IsEdit: this.isEdit,
          ID: this.id == "" ? null : this.id,
          Remark: this.remark,
        };

        if (this.oldPosition != this.user.position) {
          //更改了职务
          addInfo.ManualPosition = this.user.position;
        }
        webService.addInvestedCompanyContact(addInfo).then((res) => {
          if (res.data.result) {

            if (this.$route.query.id ||
              this.$route.query.companyData ||
              this.$route.query.relationshipId
            ) {
              if (this.$route.query.orgId) {
                this.$bus.$emit("busfreshComp", { orgId: this.$route.query.orgId });
              } else if (this.$route.query.id) {
                this.$bus.$emit("busfreshContact", { id: this.$route.query.id });
                this.$bus.$emit("busfreshPwC");
              }
              Toast.success(res.data.resultMsg);
              let _this = this;

              setTimeout(() => {
                if (_this.url && _this.url.indexOf('myFavorites/') > -1) {
                  // console.log(_this.url);
                  _this.$router.push({
                    path: "/myFavorites/" + Math.random() * 1000000,
                  });
                } else {
                  _this.$router.go(-1);
                }
              }, 800);
            } else {
              this.$router.push({
                path: "/home/addSuccess",
                query: {
                  isEdit: this.isEdit,
                  Passed: res.data.returnCode,
                },
              });
            }

          } else {
            Toast.fail("已存在该关系");
          }
        });
      }
    },
    valudateBeforeSubmit () {
      var isOk = true;
      if (_.trim(this.company.name) == "") {
        this.company.name = "";
        this.$refs.company.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.user.name) == "") {
        this.user.name = "";
        this.$refs.user.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.relationDeepth.name) == "") {
        this.$refs.relationDeepth.setAttribute(
          "class",
          "input-style change"
        );
        isOk = false;
      }
      if (_.trim(this.user.position) == "" && !this.positionDisable) {
        this.$refs.position.setAttribute("class", "input-style change");
        isOk = false;
      }
      return isOk;
    },
    goBack () {
      this.$router.go(-1);
    },
    getMyDeBounce (ev, type) {
      if (type == "company") {
        companyDe(ev);
      }
      if (type == "user") {
        userDe(ev);
      }
    },
    getFilterList (ev, type) {
      console.log("getFilterList");
      if (type == "company") {
        if (!this.companyDisable) {
          this.company.show = this.company.name != '';
          this.getMyDeBounce(ev, type)
        }
      } else if (type == "user" && !this.isEdit) {
        //根据选中的机构过滤用户
        if (this.company.item != null && this.company.item.apiID) {
          this.user.loading = true;
          webService.getMemberList(this.company.item.apiID, "")
            .then((res) => {
              this.user.loading = false;
              this.userList = res.data;
              this.user.showList = this.userList;
              this.user.show = this.user.showList.length > 0;
            });
        } else {
          this.user.showList = [];
        }
      }
      if (type == "responsibility") {
        this.responsibility.showList = _.sortBy(
          this.responsibilityList,
          ["sort"]
        );
        this.responsibility.show = true;
      }
      if (type == "relationDeepth") {
        this.relationDeepth.showList = _.sortBy(this.deepList, [
          "sort",
        ]);
        this.relationDeepth.show = true;
      }
    },
    getMycompanyList (ev) {
      console.log("getMycompanyList");
      if (this.companyDisable) return;

      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      this.company.loading = true;
      webService.getCompanysByName(this.company.name).then((res) => {
        this.company.loading = false;
        var index = 0;
        res.data.forEach(element => {
          index++;
          element.index = index + 1;
        });
        this.company.showList = res.data;
        this.company.show = this.company.showList.length > 0;
      });
      if (!this.isEdit) {
        this.user.showList = [];
        this.user.item = null;
        this.user.name = "";
      }
    },
    selectChange (ev, type) {
      setTimeout(() => {
        if (type == "company") {
          //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
          //   if (this.company.item) {
          //     if (
          //       (this.company.item.name &&
          //         this.company.item.name !== this.company.name) ||
          //       !this.company.item.name
          //     ) {
          //       //Toast.fail('请选择系统中存在的机构');
          //       this.company.item = null;
          //       this.company.show = false;
          //     }
          //   }
          if (type == "user") {
            console.log("selectChange --user:" + ev);
            //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
            if (this.user.item) {
              if (
                (this.user.item.name &&
                  this.user.item.name !== this.user.name) ||
                !this.user.item.name
              ) {
                this.user.item = null;
                this.user.show = false;
              }
            }
          }
          if (type == "responsibility") {
            //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
            if (
              this.responsibility &&
              this.responsibility.item.name &&
              this.responsibility.item.name !==
              this.responsibility.name
            ) {
              this.responsibility.item = null;
              this.responsibility.show = false;
            }
          }
        }
      }, 300);
    },
    getUserList (ev) {
      console.log("getUserList");
      if (this.userDisable) return;

      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      //先必须选择机构
      if (this.company.item != null && this.company.item.apiID) {
        this.user.loading = true;
        webService
          .getMemberList(
            this.company.item.apiID,
            this.user.name
          )
          .then((res) => {
            this.user.loading = false;
            this.user.showList = res.data;
            this.user.show = this.user.showList.length > 0;
          });
      }
    },
    selectItem (item, type) {
      console.log("selectItem");
      if (type == "company") {
        if (item) {
          this.company.item = item;
          this.company.show = false;
          this.company.name = item.name;
        }
      }
      if (type == "responsibility") {
        if (item) {
          this.responsibility.item = item;
          this.responsibility.name = item.name;
          this.responsibility.show = false;
        }
      }
      if (type == "relationDeepth") {
        if (item) {
          this.relationDeepth.item = item;
          this.relationDeepth.name = item.name;
          this.relationDeepth.show = false;
        }
      }
      if (type == "user") {
        if (item) {
          this.user.item = item;
          this.user.show = false;
          this.user.position = item.position;
          this.oldPosition = item.position;
          this.user.name = item.name;
          if (this.user.item.responsibilityId) {
            var resInfo = _.find(this.responsibilityList, [
              "id",
              this.user.item.responsibilityId,
            ]);
            this.responsibility.item = resInfo;
            this.responsibility.name =
              resInfo == null ? "" : resInfo.name;
          } else {
            this.responsibility.item = null;
            this.responsibility.name = "";
          }
        }
      }
    },
    onBlur (type) {
      console.log("onBlur");
      setTimeout(() => {
        //选择了机构后，用户需要重新选择
        if (type == "company") {
          this.company.showList = [];
          this.company.show = false;
        }
        if (type == "responsibility") {
          this.responsibility.show = false;
        }
        if (type == "user") {
          this.user.show = false;
        }
        if (type == "relationDeepth") {
          this.relationDeepth.show = false;
        }
      }, 100);
    },
    gosuccess () {
      this.$router.push({
        path: "/home/addSuccess",
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../../styles/theme.scss";
.top-title {
  font-family: "PingFangSC-Medium";
  font-size: 26px;
  color: #2d2d2d;
  text-align: center;
  line-height: 36px;
}
.left-icon {
  font-size: 24px;
  padding-left: 1rem;
  color: darkgray;
  line-height: 66px;
}
.change::-webkit-input-placeholder {
  color: #c52a1a;
}
.input-style {
  font-weight: bold;
  border: none;
  border-bottom: 1px solid #dedede;
}
/deep/ .van-field__value {
  border: none;
  border-bottom: 1px solid #dedede;
  //  ::-webkit-input-placeholder {
  //     color: red;
  // }
}
.add-Info {
  height: calc(100% - 50px);
}
.title-right {
  flex: 1;
  text-align: right;
  padding: 1rem;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
}
.content-info {
  height: 100%;
  justify-content: space-between;
}
.type-row {
  font-size: 14px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
}
.user-select {
  position: absolute;
  z-index: 100; //border: 2px solid #f5f2f2e0;
  width: 95%;
  margin-top: 27px;
  max-height: 300px;
  overflow: auto;
}
.down-list {
  padding: 12px;
  margin-right: 12px;
  background-color: #f3f2f2;
}
input:read-only {
  background: #fff;
  color: #2d2d2d;
}
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
input:-ms-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
.type-left {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 24rem;
  color: #2d2d2d;
  text-align: left;
  padding-left: 16px;
  padding-top: 10px;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
}
.type-right {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  color: #969799;
  text-align: right;
  margin-left: 12px;
}
.must-label {
  margin-right: 10px;
}
.must-input {
  margin-left: -8px;
  color: #c52a1a;
  font-size: 14px;
}
.submit-button {
  margin: 20px;
}
/deep/ .van-cell {
  display: flex;
  flex-direction: column;
}
/deep/ .van-button--round {
  border-radius: 1px;
}
/deep/ .van-button--info {
  background-color: #c52a1a;
  border: 1px solid #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/views/add/AddRelationship/companyRelationship.vue